import _get from 'lodash/get';
import { DEFAULT_APP_PATH } from 'appRoot/constants';

export const selectRedirectOnErrorPath = state => _get(state, ['error', 'redirectOnErrorPath']) || DEFAULT_APP_PATH;
export const selectErrorType = state => _get(state, ['error', 'errorType']);
